import type { WalletProviderConnectAddress } from '@dynamic-labs-sdk/client/core';

type ParseBitcoinConnectionResultParams = {
  connectedAddresses: {
    address: string;
    publicKey?: string;
    purpose: string;
  }[];
};

export const parseBitcoinConnectionResult = ({
  connectedAddresses,
}: ParseBitcoinConnectionResultParams) => {
  // Xverse will return other addresses/types that we don't support
  // so we filter them out
  const filteredAddresses = connectedAddresses.filter(
    (address) => address.purpose === 'ordinals' || address.purpose === 'payment'
  );

  const addresses: WalletProviderConnectAddress[] = filteredAddresses.map(
    (account) => ({
      address: account.address,
      publicKey: account.publicKey,
      type: account.purpose === 'payment' ? 'payment' : 'ordinals',
    })
  );

  // put ordinals addresses first, as they should be the main walletAccount address
  addresses.sort((a) => (a.type === 'ordinals' ? -1 : 1));

  return {
    addresses,
  };
};
